var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EnrollmentStatusDialog',{attrs:{"enrollment":_vm.enrollment,"loading":_vm.loading,"error":_vm.error},on:{"dialog-closed":_vm.cancelDialog,"update-status":_vm.updateStatus}})}
var staticRenderFns = []

export { render, staticRenderFns }